import type { Coding, ValueSet } from '@medplum/fhirtypes'
import { ITEM_WEIGHT_EXTENSION_URL } from '#src/structureDefinitions.ts'
import {
  ASSESSMENT_ANSWERS_SYSTEM,
  type TerminologyLibrary,
} from '#src/terminology/types.ts'

export interface ResolvedAnswerOption {
  coding: Coding
  // From the concept's itemWeight extension, for a scored answer set.
  score?: number
}

function findAnswerSet(
  library: TerminologyLibrary,
  url: string | undefined
): ValueSet | undefined {
  return url
    ? library.answerSets.find((answerSet) => answerSet.url === url)
    : undefined
}

export function answerSetOptions(
  library: TerminologyLibrary,
  url: string
): ResolvedAnswerOption[] {
  const answerSet = findAnswerSet(library, url)
  return (answerSet?.compose?.include ?? []).flatMap((include) =>
    (include.concept ?? []).map((concept): ResolvedAnswerOption => {
      const defined =
        include.system === ASSESSMENT_ANSWERS_SYSTEM
          ? library.answerCodes.concept?.find(
              (candidate) => candidate.code === concept.code
            )
          : undefined
      const weight = concept.extension?.find(
        (extension) => extension.url === ITEM_WEIGHT_EXTENSION_URL
      )
      const score = weight?.valueDecimal ?? weight?.valueInteger
      const option: ResolvedAnswerOption = {
        coding: {
          system: include.system,
          code: concept.code,
          display: concept.display ?? defined?.display ?? concept.code,
        },
      }
      if (score !== undefined) {
        option.score = score
      }
      return option
    })
  )
}
